import Core from '../plugin-core-system/core.class.js';
import TranslatedLang from '../helper/translated-lang.helper.js';
import Splide from '@splidejs/splide';

export default class CsSplide extends Core {

  static options = {
    sliderConfigBase: {
      type: 'slide',
      lazyLoad: 'nearby'
    },
    sliderMultipleItemsConfig: {
      perPage: 5,
      arrows: false,
      gap: '60px',
      breakpoints: {
        1160: {
          gap: '30px'
        },
        920: {
          perPage: 5
        },
        620: {
          perPage: 3
        },
        420: {
          perPage: 2
        }
      },
    },
    sliderHomeConfig: {
      arrows: false,
      autoplay: true,
    },
    slider3ItemsConfig: {
      perPage: 3,
      gap: '32px',
      breakpoints: {
        620: {
          perPage: 2
        },
        420: {
          perPage: 1
        }
      },
    },
    slider3LargeItemsConfig: {
      perPage: 3,
      gap: '32px',
      breakpoints: {
        920: {
          perPage: 2
        },
        620: {
          perPage: 1
        }
      },
    },
    sliderDefaultI18n: {
      i18n: {
        prev: 'Previous Slide',
        next: 'Next Slide',
        first: 'Go to the first slide',
        last: 'Go to the last slide',
        slideX: 'Go to slide %s',
        pageX: 'Go to page %s',
        play: 'Start autoplay',
        pause: 'Pause autoplay',
        carousel: 'Slider',
        slide: 'Slide',
        select: 'Select a slide to display',
        slideLabel: '%s of %s'
      }
    }
  };

  initializeSplide(options = {}) {
    const splide = new Splide(this.el, options);
    splide.on('mounted', () => {
      this.startStopAnimation(splide);
    });
    splide.mount();
  }

  startStopAnimation(splide) {
    const autoplay = splide.Components.Autoplay;

    // Check initial state: if animations are already disabled (e.g. cookie was set before slider mounted)
    if (document.body.classList.contains('h-stop-animations')) {
      autoplay.pause();
    }

    // Listen for future toggle events from the accessibility animation
    document.addEventListener('splideSlidersFound', function(e) {
      if (e.detail.found === true) {
        if (autoplay.isPaused()) {
          autoplay.play();
        }
      } else {
        autoplay.pause();
      }
    });
  }

  init() {
    let sliderOptions = CsSplide.options.sliderConfigBase;

    try {
      const langConfig = TranslatedLang.translatedLangConfig('splide', 'i18n');
      sliderOptions = { ...sliderOptions, ...langConfig };
    } catch {
      sliderOptions = { ...sliderOptions, ...CsSplide.options.sliderDefaultI18n };
    }

    if (this.el.matches('.js-splide-slider--multiple-items')) {
      sliderOptions = { ...sliderOptions, ...CsSplide.options.sliderMultipleItemsConfig };
      this.initializeSplide(sliderOptions);
    } else if (this.el.matches('.js-splide-slider--3-items')) {
      sliderOptions = { ...sliderOptions, ...CsSplide.options.slider3ItemsConfig };
      this.initializeSplide(sliderOptions);
    } else if (this.el.matches('.js-splide-slider--home')) {
      sliderOptions = { ...sliderOptions, ...CsSplide.options.sliderHomeConfig };
      this.initializeSplide(sliderOptions);
    } else if (this.el.matches('.js-splide-slider--3-large-items')) {
      sliderOptions = { ...sliderOptions, ...CsSplide.options.slider3LargeItemsConfig };
      this.initializeSplide(sliderOptions);
    } else {
      sliderOptions = { ...sliderOptions };
      this.initializeSplide(sliderOptions);
    }
  }
}
